import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import type { AuthUser } from '@/types/auth.types'

// ─────────────────────────────────────────────────────────────
// Auth Zustand store
// Persisted to sessionStorage so a tab refresh keeps the session,
// but closing the browser clears it.
// ─────────────────────────────────────────────────────────────

interface AuthState {
  user:      AuthUser | null
  isLoading: boolean

  setUser:    (user: AuthUser | null) => void
  setLoading: (v: boolean) => void
  clearAuth:  () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user:      null,
      isLoading: true,

      setUser:    (user)      => set({ user }),
      setLoading: (isLoading) => set({ isLoading }),
      clearAuth:  ()          => set({ user: null, isLoading: false }),
    }),
    {
      name:    'olly-auth',
      storage: createJSONStorage(() => sessionStorage),
      // Only persist essential fields — not isLoading
      partialize: (state): Pick<AuthState, 'user'> => ({ user: state.user }),
    }
  )
)
